import { useEffect, useState } from "react";

// Fetches live data from the DB-backed API, keeping the static fallback on screen
// immediately and only swapping in fresh data if the request succeeds with rows.
export function useApiData(fetchFn, fallbackData, mapFn = (rows) => rows) {
  const [data, setData] = useState(fallbackData);

  useEffect(() => {
    let cancelled = false;

    fetchFn()
      .then(({ data: body }) => {
        if (cancelled) return;
        const rows = body?.data;
        if (Array.isArray(rows) && rows.length > 0) {
          setData(mapFn(rows));
        } else if (rows && typeof rows === "object" && Object.keys(rows).length > 0) {
          setData(mapFn(rows));
        }
      })
      .catch(() => {
        // Silently keep the static fallback data — API/DB may be unavailable.
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return data;
}
